import React from "react";
import "./pagination.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

const Pagination = ({ currentPage, totalPages, onNextPage, onPrevPage }) => {
  if (!totalPages) {
    return null
  }
  
  return (
    <div>
      <button className="pagination-button" onClick={onPrevPage} disabled={currentPage === 0}><FontAwesomeIcon icon={faChevronLeft} /></button>
      
      <span className="pagination-index">{currentPage + 1}</span>

      <button className="pagination-button"onClick={onNextPage} disabled={currentPage + 1  === totalPages}><FontAwesomeIcon icon={faChevronRight} /></button>
    </div>
  );
};

export default Pagination;
